import React, { useEffect } from 'react';
import styles from './add-menu-page.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import AddMenuDay from '../../components/AddMenuDay/AddMenuDay';

import { useDispatch, useSelector } from 'react-redux';
import { addMenuDayDefaultRedux, resetMenuDay } from '../../store/slices/menuSlice';
import { pathHome } from '../../path';

const AddMenuPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { group_id } = useParams();

  const menuDay = useSelector((state) => state.menu.menuDay);
  const isMenuDay = Object.keys(menuDay).length;

  const addMenuDayDefault = () => {
    dispatch(addMenuDayDefaultRedux());
  };

  useEffect(() => {
    return () => {
      dispatch(resetMenuDay());
    };
  }, []);

  return (
    <div className={styles.addMenu_wrapper}>
      <div className={styles.header_wrapper}>
        <div
          className={styles.header_back_btn}
          onClick={() => navigate(`/${pathHome}/menu/` + group_id)}>
          <svg
            width="12"
            height="18"
            viewBox="0 0 12 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0 8.99999L11.25 0.339737V17.6602L0 8.99999Z" fill="white" />
          </svg>
          Назад
        </div>
      </div>
      {isMenuDay ? <AddMenuDay /> : addMenuDayDefault()}
    </div>
  );
};

export default AddMenuPage;
